module.exports = __webpack_public_path__ + "img/connect_icon.86e5caaf.png";